module.exports = __webpack_public_path__ + "static/BTP_90days-eade6bee13863be92428c1689f40f25b.png";